<template>
  <div>
    <header class="yanmenu">
      <router-link to="/panel" tag="div" class="header">
        <svg version="1.1" id="katman_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             x="0px" y="0px"
             viewBox="0 0 164.4 170.3">
          <path fill="#ccc" d="M83.1,0.1C109.7,0,135.7,3.8,161,12c2.8,0.9,3.6,2.2,3.4,5c-3.5,57.7-26.9,105.7-70.3,143.8
		c-3,2.6-6.3,5-9.3,7.6c-1.8,1.6-3.2,1.5-5.1,0c-21.1-16.3-38.7-35.8-52.2-58.9C16,89.6,8,68.4,3.6,45.8c-1.9-9.7-2.9-19.4-3.5-29.2
		c-0.2-2.4,0.6-3.7,3-4.5c23.3-7.5,47.2-11.6,71.7-12C77.6,0.1,80.4,0.1,83.1,0.1z M91.4,16.6c-29-0.2-49.9,2.4-70.5,7.6
		c-3,0.8-3.6,2.2-3.2,5c2.8,21.3,8.6,41.6,18.2,60.9c10.7,21.4,25.1,40,42.9,55.9c1.7,1.5,3.3,3.5,5.9,1.1
		c8.7-7.9,17-16.2,24.2-25.5c21-27.1,33.5-57.6,37.9-91.6c0.5-3.7-0.4-5.1-4-6C123.4,19.2,103.7,16.7,91.4,16.6z"/>
          <path fill="#ccc" d="M82.3,126.5c-8-7.5-13.9-15.2-19.5-23.1c-6.8-9.6-12.3-20-16.9-30.8c-1.3-3.1-0.9-4.3,2.6-5
		c22.5-4.2,45.1-4,67.6,0c3.2,0.6,4.1,1.7,2.6,4.6c-1.3,2.7-2.6,5.5-3.7,8.3c-1.1,2.9-2.9,3.5-5.8,3c-11.9-2.3-23.9-2.6-35.9-2.2
		c-4.2,0.2-4.4,0.5-2.1,4.1c2.3,3.8,4.5,7.7,7.3,11c3.1,3.7,4,7.6,3.8,12.2C82.1,114.3,82.3,119.8,82.3,126.5z"/>
          <path fill="#ffc107" d="M80.3,33.1c16.5-0.1,30.9,1.3,45.2,4c2.8,0.5,3.5,1.4,2.7,4.1c-1.2,4-0.9,9.3-3.4,11.7
		c-1,1.1-7.8-0.4-11.8-0.9c-23.3-3.2-46.6-2.8-69.7,1.4c-3,0.5-4.5,0.1-4.8-3c-0.1-0.7-0.4-1.3-0.5-2c-2.7-13.5-4.9-10,8.4-12.5
		C58.2,33.7,70.2,32.8,80.3,33.1z"/>
        </svg>

      </router-link>

      <SayacOkumaMenu></SayacOkumaMenu>


      <div class="footer">
        <div class="dropdown" style="
    display: block;
    text-align: center;
    padding-bottom: 10px;
" v-if="this.$store.getters.Admin>0">
          <a href="#" class="ustmenu kullanici text-center" id="UstMenuButon" data-toggle="dropdown" aria-haspopup="true"
             aria-expanded="false">
            <b style="opacity: 0.6;">
            <svg id="Layer_1" enable-background="new 0 0 513 513" height="512" viewBox="0 0 513 513" width="512"
                 xmlns="http://www.w3.org/2000/svg">
              <g>
                <g opacity=".8">
                  <g>
                    <path
                      d="m80.5 392.543v-144c0-55.229 45.402-100 100.63-100h-58c-55.229 0-100 44.771-100 100v144c0 55.229 44.771 100 100 100h58c-55.228 0-100.63-44.771-100.63-100z"
                      fill="#000000" opacity="0.2"/>
                  </g>
                </g>
                <g>
                  <ellipse cx="256.5" cy="260" fill="#ffc107" rx="25.029" ry="24.965"
                           transform="matrix(.707 -.708 .708 .707 -108.722 257.748)"/>
                </g>
                <g>
                  <path
                    d="m392.5 513h-272c-66.168 0-120-53.832-120-120v-144c0-66.168 53.832-120 120-120h272c66.168 0 120 53.832 120 120v144c0 66.168-53.832 120-120 120zm-272-344c-44.112 0-80 35.888-80 80v144c0 44.112 35.888 80 80 80h272c44.112 0 80-35.888 80-80v-144c0-44.112-35.888-80-80-80z"
                    fill="#ffffff"/>
                </g>
                <g>
                  <path
                    d="m305.5 378h-98c-60.103 0-109-48.897-109-109 0-11.046 8.954-20 20-20s20 8.954 20 20c0 38.047 30.953 69 69 69h98c38.047 0 69-30.953 69-69 0-11.046 8.954-20 20-20s20 8.954 20 20c0 60.103-48.897 109-109 109z"
                    fill="#ffffff"/>
                </g>
                <g>
                  <path
                    d="m331.5 89c-11.046 0-20-8.954-20-20 0-15.99-13.009-29-29-29h-52c-15.991 0-29 13.01-29 29 0 11.046-8.954 20-20 20s-20-8.954-20-20c0-38.047 30.953-69 69-69h52c38.047 0 69 30.953 69 69 0 11.046-8.954 20-20 20z"
                    fill="#ffc107"/>
                </g>
              </g>
            </svg>
            </b>
          </a>
          <div class="dropdown-menu" aria-labelledby="UstMenuButon">
            <a @click="SistemAyarlariModal=true" class="golgehover"><i
              class="flaticon2-browser-2"></i>
              <small>Sistem Ayarları</small>
            </a>
            <a @click="HesapModal=true" class="golgehover"><i
              class="flaticon2-protected"></i>
              <small>{{ $t('mSpesiyal.1') }}</small>
            </a>
            <a @click="MailEntegrasyonModal=true" class="golgehover"><i
              class="flaticon2-mail-1"></i>
              <small>Mail Entegrasyonu</small>
            </a>
            <router-link to="/kullanici" class="golgehover"><i
              class="flaticon2-lock"></i>
              <small>{{ $t('mSpesiyal.4') }}</small>
            </router-link>
          </div>
        </div>
        <div class="dropdown spmenu">
          <a href="#" class="ustmenu kullanici" @click="CikisYap"><b class="bold ">
            <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
                 xmlns="http://www.w3.org/2000/svg">
              <g>
                <path
                  d="m240.239 244.407c-11.182 3.625-23.11 5.593-35.5 5.593-63.513 0-115-51.487-115-115s51.487-115 115-115c12.39 0 24.318 1.968 35.5 5.593-46.138 14.961-79.5 58.284-79.5 109.407s33.362 94.446 79.5 109.407zm102.261 187.593v-27c0-33.137 26.863-60 60-60h-60c-33.137 0-60 26.863-60 60v27c0 33.137 26.863 60 60 60h60c-33.137 0-60-26.863-60-60z"
                  fill="#000000" opacity="0.2"/>
                <path
                  d="m437.5 329.361v-26.361c0-33.084-26.916-60-60-60s-60 26.916-60 60v26.022c-31.902 10.524-55 40.596-55 75.978v27c0 44.112 35.888 80 80 80h69c44.112 0 80-35.888 80-80v-27c0-35.011-22.617-64.82-54-75.639zm-80-26.361c0-11.028 8.972-20 20-20s20 8.972 20 20v22h-40zm94 129c0 22.056-17.944 40-40 40h-69c-22.056 0-40-17.944-40-40v-27c0-22.056 17.944-40 40-40h69c22.056 0 40 17.944 40 40zm-101-297c0-74.439-60.561-135-135-135s-135 60.561-135 135 60.561 135 135 135 135-60.561 135-135zm-135 95c-52.383 0-95-42.617-95-95s42.617-95 95-95 95 42.617 95 95-42.617 95-95 95z"
                  fill="#8996a0"/>
                <path
                  d="m40.5 512c-11.046 0-20-8.954-20-20 0-100.355 81.645-182 182-182h20c11.046 0 20 8.954 20 20s-8.954 20-20 20h-20c-78.299 0-142 63.701-142 142 0 11.046-8.954 20-20 20zm336.333-118c-13.807 0-25 11.193-25 25s11.193 25 25 25 25-11.193 25-25-11.193-25-25-25z"
                  fill="#ffc107"/>
              </g>
            </svg>
          </b>
            <small>{{ this.$store.getters.KullaniciBilgi.KullaniciAdi }}</small>
          </a>
        </div>
      </div>
    </header>

    <MailEntegrasyon v-if="MailEntegrasyonModal" :Modal="MailEntegrasyonModal"
                     @Modal="MailEntegrasyonModal=false"></MailEntegrasyon>
    <SistemAyarlari v-if="SistemAyarlariModal"
                    @SistemAyarlariModal="SistemAyarlariModal=false"
                    :SistemAyarlariModal="SistemAyarlariModal"></SistemAyarlari>
    <Hesap v-if="HesapModal" @HesapModal="HesapModal=false"
           :HesapModal="HesapModal"></Hesap>

  </div>
</template>

<script>
import SistemAyarlari from "../Pack/Genel/SistemAyarlari";
import Hesap from "../Pack/Genel/Hesap";
import MailEntegrasyon from "../Pack/Entegrasyon/MailEntegrasyon";
import SayacOkumaMenu from "./Menu/SayacOkumaMenu";

export default {
  components: {
    SayacOkumaMenu,
    MailEntegrasyon,
    Hesap,
    SistemAyarlari
  },
  data() {
    return {
      HesapModal: false,
      SistemAyarlariModal: false,
      MailEntegrasyonModal: false,
      HesapBilgi: null,

    }
  },
  methods: {

    CikisYap() {
      this.$confirm("Oturumu kapatmak istediğinize eminmisiniz?", "Oturum Kapatılacak", {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Cikis();
      }).catch(() => {
        this.$message.info("Oturum Kapatılmadı");
      });
    },
    Cikis() {
      this.$store.dispatch("Get", {path: 'spesiyal/cikis', loading: false})
        .then(response => {
          if (response.Durum === 'OK') {
            this.$store.dispatch("logout");
          }
        });
    },

    SantralKontrol() {
      this.$store.dispatch("Get", {path: 'spesiyal/santralizle/'})
        .then(response => {
          if (response.Durum === 'OK') {
            if (response.Liste) this.SantralDurum.push(response.Liste);
            setTimeout(() => {
              this.SantralKontrol();
            }, 10000);
          } else {
            this.$message.error(response.Mesaj);
          }
        });
    },
    Anlik() {

    }
  },
  created() {


  },

}
</script>

<style scoped>
.hesapsorun {
  position: relative;
  color: #ea4335 !important;
  -webkit-animation: flashhover linear 2s infinite;
  animation: flashhover linear 2s infinite;
}

.aktifabone {
  position: relative;
  color: #fff !important;
  background: #00c292;
  line-height: 20px;
}

.aktifabone svg {
  top: -5px;
  position: relative;
}

.aktifabone span {
  font-size: 12px;
  font-weight: bold;
  top: -5px;
  position: relative;
}

.hesapsorun:hover {
  color: #ea4335 !important;
  background: #fff !important;
  -webkit-animation: flashhover linear 2s infinite;
  animation: flashhover linear 2s infinite;
}

.hesapsorun i {
  font-size: 16px;
  position: relative;
  top: 4px;
}

@-webkit-keyframes flash {
  0% {
    background: #ea4335;
  }
  50% {
    background: #333333;
  }
  100% {
    background: #ea4335;
  }
}

@keyframes flash {
  0% {
    background: #ea4335;
  }
  50% {
    background: #333333;
  }
  100% {
    background: #ea4335;
  }
}

@-webkit-keyframes flashhover {
  0% {
    color: #ea4335;
  }
  50% {
    color: #333333;
  }
  100% {
    color: #ea4335;
  }
}

@keyframes flashhover {
  0% {
    color: #ea4335;
  }
  50% {
    color: #333333;
  }
  100% {
    color: #ea4335;
  }
}

@-webkit-keyframes flashsvg {
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.3;
  }
}

@keyframes flashsvg {
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.3;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Doc/Header.vue